@if (HasRequiredPermissions) {
<div class="bg-white p-6 rounded-lg shadow w-full max-w-none" [class.my-8]="!isNested" [class.my-4]="isNested">
  <div class="mb-4">
    <h1 class="text-lg font-medium text-gray-700" data-testid="list-title">
      {{ 'entities.accesscard.pluralName' | translate }} ({{ totalSeen }}/{{ listView()?.entities()?.total }})
    </h1>
  </div>
  <app-list-view [entityType]="ComponentEntityClass"
    [contextMenuItems]="contextMenuItems"
    [showActions]="true"
    [canEdit]="canEdit.bind(this)"
    (entitySelected)="selectSingleItem($event)"
    (editAction)="editSelectedItem($event)"
    (deleteAction)="deleteSelectedItem($event)"
    [dismissEntity]="dismissEntityState.bind(this)"
    [onDismissAdded]="dismissEntityState.bind(this)"
    [onRowDismiss]="handleRowDismiss.bind(this)"
    [pagination]="{
                      enabled: true,
                      pageLengths: [5, 10, 20, 50, 100, 300],
                      defaultPageLength: 5,
                      searchColumns: ['iD_SP', 'isRevoked', 'pointOfService.name', 'currentVisit.company'],
                      sortableColumns: null
                    }"
    [paginatorType]="'button'"
    [showHeader]="false"
    (createButtonClick)="openCreateModal()">
    <!-- Onglets positionnés entre search et tableau via le slot custom-filters -->
    <div slot="custom-filters" class="flex gap-1 bg-gray-100 rounded-lg p-1 w-fit" style="margin-left: auto">
      <button class="px-4 py-1.5 text-sm font-medium rounded-md transition-all duration-200"
        [class.bg-white]="activeTab() === 'active'"
        [class.shadow-sm]="activeTab() === 'active'"
        [class.text-blue-600]="activeTab() === 'active'"
        [class.text-gray-500]="activeTab() !== 'active'"
        [class.hover:text-gray-700]="activeTab() !== 'active'"
        (click)="selectTab('active')">
        {{ 'entities.accesscard.tabs.active-cards' | translate }}
      </button>
      <button class="px-4 py-1.5 text-sm font-medium rounded-md transition-all duration-200"
        [class.bg-white]="activeTab() === 'revoked'"
        [class.shadow-sm]="activeTab() === 'revoked'"
        [class.text-blue-600]="activeTab() === 'revoked'"
        [class.text-gray-500]="activeTab() !== 'revoked'"
        [class.hover:text-gray-700]="activeTab() !== 'revoked'"
        (click)="selectTab('revoked')">
        {{ 'entities.accesscard.tabs.revoked-cards' | translate }}
      </button>
    </div>
    <!-- Colonne ID -->
    <app-list-table-column key="iD_SP"
      title="{{ 'entities.accesscard.propreties.iD_SP' | translate }}"
      type="text"
      [sortable]="true"
      align="left">
    </app-list-table-column>
    <!-- Colonne Status (affiche "Revoked" en gris pour les cartes révoquées) -->
    <app-list-table-column key="status"
      title="{{ 'entities.accesscard.propreties.status' | translate }}"
      type="custom">
      <ng-template #customTemplate let-entity>
        @if (entity?.isRevoked) {
        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-s font-medium bg-gray-300 font-light text-black">{{ 'entities.accesscard.propreties.is-revoked' | translate }}</span>
        } @else {
        <app-reactive-badge [status]="$safeNavigationMigration(entity?.status)"
          [lookupData]="accessCardStatusLookup()"
          [Skin]="Skin"
          [isEditMode]="true"
          (statusChange)="updateEntityProperty(entity, 'status', $event)">
        </app-reactive-badge>
        }
      </ng-template>
    </app-list-table-column>
    <!-- Colonne Visitor (via currentVisit.visitor.fullName) -->
    <app-list-table-column key="currentVisit.visitor.fullname"
      title="{{ 'entities.accesscard.propreties.visitor' | translate }}"
      type="text"
      [sortable]="true"
      align="left">
    </app-list-table-column>
  </app-list-view>
  <!-- Vue de détail -->
  <div class="fixed top-0 right-0 h-full z-50 min-w-[350px]"
    [style.width.px]="currentWidth()"
    [hidden]="!isModalOpen()">
    <div class="absolute left-0 top-0 h-full w-2 hover:w-3 hover:bg-gray-600 hover:shadow-md cursor-[ew-resize] transition-all z-[999]"
      (mousedown)="startResize($event)">
    </div>
    <div class="bg-white rounded-lg shadow-xl p-1 h-full">
      <app-access-card-detail #accessCardDetail
        [isModal]="true"
        [dataService]="dataService"
        [fkPointOfServiceId]="fkPointOfServiceId"
        (closeModal)="closeModal($event)"
        (itemSaved)="onItemUpdated($event)"
        (databaseUpdated)="closeModal(true)"
        [EntityInstance]="selectedItem()">
      </app-access-card-detail>
    </div>
  </div>
</div>
}